import * as React from 'react'
import { INVESTOR_TOP_LIST_COUNT } from '../../../pages/investors/[shortname]'
import { Article, InvestorNews } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { ExternalNewsList } from './ExternalNewsList'
import { InvestorFinanceNewsList } from './InvestorFinanceNewsList'
import { ViewMoreLink } from '../../common/ViewMoreLink'
import { NewsPicksNewsList } from './NewsPicksNewsList'
import { css } from '@emotion/react'
import { Card } from 'plume-ui'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { FullwidthArticleCard } from '../../common/FullwidthArticleCard'

type Props = {
  shortname: string
  news: InvestorNews
  articles: Article[]
}

export const InvestorNewsSection: React.FC<Props> = (props) => {
  return (
    <>
      <CardTitle>ニュース</CardTitle>
      <InvestorFinanceNewsList list={props.news.finance.data} />
      <ViewMoreLink
        isHidden={props.news.finance.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/finance-news?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/finance-news`}
        count={props.news.finance.count}
      />
      <NewsPicksNewsList investorShortname={props.shortname} />
      <ExternalNewsList list={props.news.external.data} />
      <ViewMoreLink
        isHidden={props.news.external.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/external-news?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/external-news`}
        count={props.news.external.count}
      />
      {props.articles.length > 0 ? (
        <Card
          css={css`
            margin-top: 30px;
          `}
        >
          <CardInnerTitle title="オリジナル記事" />
          {props.articles.map((article) => (
            <FullwidthArticleCard article={article} key={article.id} />
          ))}
        </Card>
      ) : null}
    </>
  )
}
